import React from 'react';

export const AddToEstimate = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_172_262)">
            <path
                d="M14.6663 16H1.33301V2C1.33301 0.897333 2.23034 0 3.33301 0H12.6663C13.769 0 14.6663 0.897333 14.6663 2V16ZM2.66634 14.6667H13.333V2C13.333 1.63267 13.0337 1.33333 12.6663 1.33333H3.33301C2.96567 1.33333 2.66634 1.63267 2.66634 2V14.6667ZM11.9997 3.33333H7.99967V4.66667H11.9997V3.33333ZM11.9997 7.33333H7.99967V8.66667H11.9997V7.33333ZM11.9997 11.3333H7.99967V12.6667H11.9997V11.3333ZM6.66634 2.66667H3.99967V5.33333H6.66634V2.66667ZM6.66634 6.66667H3.99967V9.33333H6.66634V6.66667ZM6.66634 10.6667H3.99967V13.3333H6.66634V10.6667Z"
                fill="#252733"
            />
        </g>
        <defs>
            <clipPath id="clip0_172_262">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
